<template>
  <div class="page-continer answer-page">
    <answer-top />
    <div class="main">
      <router-view />
      <answer-card />
    </div>
  </div>
</template>

<script>
  import answerTop from './answerTop';
  import answerCard from './answerCard';
  export default {
    name: 'answerLayout',
    components: {
      answerTop,
      answerCard
    },
    data() {return {}},
    methods: {}
  }
</script>

<style scoped lang="scss">
  @import '../../assets/css/style.scss';

  .answer-page {
    height: 100%;
  }

  .main {
    @include flex-between();
    position: relative;
    height: 730px;
  }
</style>
<style lang="scss">
  @import '../../assets/css/style.scss';
  .answer-progress {
    .answer-breadcrumb {
      .lable {
        .el-breadcrumb__inner {
          font-size: 18px;
          line-height: 25px;
        }
      }
      .el-breadcrumb__inner {
        font-size: 14px;
        line-height: 20px;
        color: $answer-text-primary;
        font-weight: normal;
      }
      .el-breadcrumb__separator {
        margin: 0 31px;
      }
      .el-progress-bar__outer {
        background: #FFF5EF;
        border: 1px solid #F8D5BC;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/questions/answerLayout.vue